@let isEmpty = history().length === 0;

<h3 class="m-0 mb-4">Storico {{ categoryLabel() }}</h3>
<div class="flex flex-column gap-3 max-h-full overflow-y-auto">
	@if ( isEmpty ) {
		<h4>Non è presente niente nello storico</h4>
	} @else {
		@for (h of history(); track h.ticketId + '-' + h.timestamp) {
			<div class="flex gap-2 align-items-center justify-content-between">
				<span>
				 {{ h.subject }}
				</span>
				<p-button icon="pi pi-times"
						  variant="outlined"
						  severity="warn"
						  size="small"
						  (onClick)="undoSingleTicket(h.ticketId)" />
			</div>
		}
	}
</div>
